<!-- item.route -->
<a class="nav-link" [ngClass]="item.classes" *ngIf="item.route && !item.externalUrl && !item.event"
  [routerLink]="[item.route]">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>
</a>

<!-- item.externalUrl -->
<a class="nav-link" [ngClass]="item.classes" *ngIf="item.route && item.externalUrl && !item.event"
  [href]="item.route+'?lang=' + transloco.getActiveLang()">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>
</a>

<!-- item.event -->
<span class="nav-link" [ngClass]="item.classes" *ngIf="item.event" (click)="onEvent(item)">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>
</span>

<!-- !item.route -->
<span class="nav-link" [ngClass]="item.classes" *ngIf="!item.route">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>
</span>

<ng-template #itemContent>
  <span [innerText]="item.name | transloco"></span>
</ng-template>
